module.exports = __webpack_public_path__ + "static/media/eirich-mesalec-s.34851765.jpg";